export { AtnDsTooltipDirective as Directive } from './tooltip.directive'
